import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../../firebase";

export const tokenAuthApi = createApi({
  reducerPath: "tokenAuthApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION || "",
  }),
  endpoints: (builder) => ({
    // Verify token and get Firebase custom token
    verifyLoginToken: builder.mutation<
      { firebaseToken: string; customerId: string; customerData: any },
      { token: string }
    >({
      query: ({ token }) => ({
        url: `https://customersitehttps-whatsappautologin-${process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION}-uc.a.run.app?token=${token}`,
        method: "POST",
        body: { token },
      }),
    }),
  }),
});

export const { useVerifyLoginTokenMutation } = tokenAuthApi;

// Helper function to authenticate with Firebase using custom token
export const authenticateWithToken = async (firebaseToken: string) => {
  try {
    const userCredential = await signInWithCustomToken(auth, firebaseToken);
    const accessToken = await userCredential.user.getIdToken();
    localStorage.setItem("accessToken", accessToken);
    return { success: true, user: userCredential.user };
  } catch (error) {
    console.error("Firebase authentication failed:", error);
    return { success: false, error };
  }
};
